// @ts-check

/**
 * encodes a query param key/value so characters like `&`, `+`, `#` and spaces
 * do not break the query string, while keeping the separators (`,` `;` `:`)
 * that the APIs expect readable in the URL
 * @function encodeParam
 * @param {string|number} value
 * @returns encoded value
 */
const encodeParam = (value) =>
  encodeURIComponent(value).replace(/%2C/g, ',').replace(/%3B/g, ';').replace(/%3A/g, ':');

/**
 *@function queryBuilder
 * @param {object} queryObject
 * @returns queryObject in a string
 */
export const queryBuilder = (queryObject) => {
  const queryString = Object.keys(queryObject || {}).reduce((accum, key) => {
    if (typeof queryObject[key] === 'number' && queryObject[key] > -1)
      return `${accum}&${encodeParam(key)}=${queryObject[key]}`;
    if (queryObject[key]) return `${accum}&${encodeParam(key)}=${encodeParam(queryObject[key])}`;
    return accum;
  }, '');

  if (queryString.length) return `?${queryString.slice(1)}`;
  return queryString;
};
